// Any config specific to PAKISTAN?

export default {
  code: 'PK',
  countryName: 'Pakistan',
  googleSiteVerificationCode: [
    'x-TZgnE73OrohBmTyx6ugJoKKTgXqF6ynGE1VNtaVHY',
    '4yk_naKgIoSnuNg092Be7i90o7q4f9B-5ebvrOF0meE',
    'jx4X6ZNSkc6wwPSM5oyk_9IL1GQpQp4TXAXyFJNKgQI'
  ],
  countryDomain: 'https://www.carrefour.pk/',
  helplineNumber: '0800 49737',
  latitude: 31.495515027934786,
  longitude: 74.35870880511509,
  countryFlagIcon: 'PK_3ea43c29b5.png',
  defaultAreaCode: 'Akram Abad Walton - Lahore',
  features: {
    languageChange: false,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: 'e5a7ed28-a188-479c-924e-9713b32328a5'
  },
  metaVerificationTag: '07b28cb1d7'
}
